/**
 * Engine API
 * Civilization Engine API
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface GamePlayerEngineDto { 
    id?: number;
    number?: number;
    playerUuid?: string;
    playerName?: string;
    playerUsername?: string;
    color?: GamePlayerEngineDto.ColorEnum;
    civilizationName?: string;
    version?: number;
    createdDate?: Date;
    lastModifiedDate?: Date;
}
export namespace GamePlayerEngineDto {
    export type ColorEnum = 'BLUE' | 'GREEN' | 'YELLOW' | 'RED' | 'PURPLE';
    export const ColorEnum = {
        BLUE: 'BLUE' as ColorEnum,
        GREEN: 'GREEN' as ColorEnum,
        YELLOW: 'YELLOW' as ColorEnum,
        RED: 'RED' as ColorEnum,
        PURPLE: 'PURPLE' as ColorEnum
    };
}